var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 37 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0949 5.26502L23.7349 10.545C24.0949 11.28 25.0549 11.985 25.8649 12.12L30.6499 12.915C33.7099 13.425 34.4299 15.645 32.2249 17.835L28.5049 21.555C27.8749 22.185 27.5299 23.4 27.7249 24.27L28.7899 28.875C29.6299 32.52 27.6949 33.93 24.4699 32.025L19.9849 29.37C19.1749 28.89 17.8399 28.89 17.0149 29.37L12.5299 32.025C9.31986 33.93 7.36986 32.505 8.20986 28.875L9.27486 24.27C9.46986 23.4 9.12486 22.185 8.49486 21.555L4.77486 17.835C2.58486 15.645 3.28986 13.425 6.34986 12.915L11.1349 12.12C11.9299 11.985 12.8899 11.28 13.2499 10.545L15.8899 5.26502C17.3299 2.40002 19.6699 2.40002 21.0949 5.26502Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.95f7c7e0ec96921e9a854710cdbd58bc.svg";
export { ForwardRef as ReactComponent };